var KrevoUrlPlugin = KrevoUrlPlugin || {};
import Config from "@/config.js";

KrevoUrlPlugin.install = function(Vue) {
  // adding instance method or property
  Vue.prototype.$kRevoUrl = function() {
    var self = this;
    self.config = Config;
    var shared = {};

    //this.$log.debug('$kRevoUrl', config);

    shared.checkUrl = function(url) {
      return url + "" === url || url === "" ? url : " "; //checking if url is a string and always return a non empty string
    };

    //gets the query part of the url and removes the question mark from it
    shared.getUrlQuery = function() {
      this.urlQuery =
        this.urlQuery || window.location.search.split("?").join("");
      return this.urlQuery;
    };

    shared.getUrlQueryFromUrl = function(url) {
      var urlString = shared.checkUrl(url); //checking if url is a string and always return at least a non empty string
      var urlSplit = urlString.split("?"); //split the url
      var urlQuery = urlSplit.length >= 2 ? urlSplit[1] : ""; //extract the query part
      return urlQuery; //return the query part of the url
    };

    //gets the url parameter specified from a given url query
    shared.getUrlParameter = function(parameterName, urlQuery) {
      var mySearch = urlQuery.toString(); //get the search part of URL
      var result = null; //set the default result returned by function
      if (mySearch.length > 0) {
        //check search string length
        var parameters = mySearch.split("&"); //split the string to an array
        var parameterNameString = parameterName.toString() + "="; //set the string we search for
        for (var k in parameters) {
          //iterate through array elements
          if (parameters[k] === parameters[k] + "") {
            //checking if we have a string (ie8 somehow ends up having functions also)
            if (parameters[k].indexOf(parameterNameString) === 0) {
              //if searched string is found
              result = decodeURIComponent(
                parameters[k].substring(parameterNameString.length)
              );
            }
          }
        }
      }
      return result;
    };

    shared.getSweepstakeNameFromUrl = function() {
      var param = shared.getUrlParameter("sweepstake", shared.getUrlQuery());
      return param !== null ? param : "model";
    };

    shared.getSweepstake = function() {
      //self.$log.debug('what', Config.sweepstakes);
      var key = shared.getSweepstakeNameFromUrl();
      return self.config.sweepstakes[key];
    };

    return shared;
  };
};
//this is needed for making the plugin methods available in the Vue instance
export default KrevoUrlPlugin;
